import { FC } from "react"
import { SchedulesEditSuccess } from "../../../module/schedules/containers/editSuccess"

export const SchedulesEditSuccessPage: FC = () => <SchedulesEditSuccess />
